/*
  Maerel London — coupon links.

  Turns a "?coupon=CODE" link into Shopify's supported discount-link flow:
  it navigates to /discount/CODE (a real top-level redirect — the only reliable
  way to apply a code), which applies the genuine discount to the session and
  carries it through to checkout. Shopify is the single source of truth for the
  amount; we never compute or display a discounted price ourselves (discount
  CODES only evaluate at checkout, and a fabricated preview would risk diverging
  from the real total). A small, honest reminder banner is shown while browsing.

  Config comes from window.MaerelCoupon (rendered in maerel-header.liquid):
    { enabled }
*/
(function () {
  'use strict';

  var CFG = window.MaerelCoupon || {};
  if (!CFG.enabled) return;

  var COOKIE = 'maerel_coupon';

  // ---- Cookies (session-scoped: the banner should track the live session, not
  //      outlive it and over-claim. The link re-applies on the next visit.) ----
  function setCookie(name, value) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }
  function clearCookie(name) {
    document.cookie = name + '=; path=/; max-age=0; SameSite=Lax';
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---- 1. Capture ?coupon= and apply it via Shopify's /discount/ navigation ----
  var params = new URLSearchParams(window.location.search);
  var fromUrl = (params.get('coupon') || '').trim();

  if (fromUrl) {
    params.delete('coupon');
    var qs = params.toString();
    var cleanPath = window.location.pathname + (qs ? '?' + qs : '');

    if (getCookie(COOKIE) === fromUrl) {
      // Already applied this session — just drop the param, no extra reload.
      setCookie(COOKIE, fromUrl);
      try { window.history.replaceState({}, document.title, cleanPath + window.location.hash); }
      catch (e) { /* noop */ }
    } else {
      // Remember it for the banner on the page we land back on, then apply for
      // real via a top-level redirect (replace() keeps it out of history).
      setCookie(COOKIE, fromUrl);
      window.location.replace(
        '/discount/' + encodeURIComponent(fromUrl) + '?redirect=' + encodeURIComponent(cleanPath)
      );
      return; // leaving the page
    }
  }

  var code = (fromUrl || getCookie(COOKIE)).trim();
  if (!code) return;

  // ---- 2. Honest reminder banner (no price claims — Shopify owns the amount) ----
  function renderBanner() {
    if (document.querySelector('.m-coupon-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'm-coupon-bar';
    bar.innerHTML =
      '<span class="m-coupon-msg">Code <strong>' + esc(code) +
        '</strong> applied — your saving shows at checkout.</span>' +
      '<button type="button" class="m-coupon-remove" aria-label="Remove coupon">Remove</button>';
    bar.querySelector('.m-coupon-remove').addEventListener('click', function () {
      clearCookie(COOKIE);
      window.location.reload();
    });
    document.body.insertBefore(bar, document.body.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderBanner);
  } else {
    renderBanner();
  }
})();
